import React, { useState, useEffect, useCallback, useRef } from 'react';
import * as Yup from 'yup';
import { format } from 'date-fns';

import { toast } from 'react-toastify';
import { Form } from '@unform/web';
// importando os services
import api from '~/services/api';
import history from '~/services/history';

// Componentes
import Button from '~/components/Form/Button';
import Select from '~/components/Form/Select';
import Card from '~/components/Card';
import Dropzone from '~/components/Dropzone';

import {
  Container,
  DS,
  Inner,
  DropContainer,
  InputArea,
  DateContainer,
  DateLabel,
  ErrorLabel,
} from './styles';

export default function LeadImport() {
  const [selectedFile, setSelectedFile] = useState([]);

  const inputRef = useRef(null);

  const [products, setProducts] = useState([]);

  const [selectedTeam, setSelectedTeam] = useState(0);

  const [dates, setDates] = useState(null);

  const [user, setUser] = useState(null);

  const atendimento = [
    { value: 1, label: 'Aleatório' },
    { value: 2, label: 'Específico' },
  ];

  const [error, setError] = useState('');

  const [dateError, setDateError] = useState('');

  const [loading, setLoading] = useState(false);

  const [showUser, setShowUser] = useState(false);

  const getProducts = useCallback(async () => {
    const response = await api.get('/produto-select');
    const data = response.data.map(res => {
      return {
        label: res.name,
        value: res.id,
        time: res.time_id,
      };
    });
    setProducts(data);
  }, []);

  const getUsers = useCallback(async team => {
    const response = await api.get(`/user-select/${team}`);

    const data = response.data.map(res => {
      return {
        label: res.name,
        value: res.id,
      };
    });

    setUser(data);
  }, []);

  useEffect(() => {
    getProducts();
  }, [getProducts]);

  function showUsers(e) {
    if (e.value === 2) {
      getUsers(selectedTeam);
      setShowUser(true);
    } else {
      setShowUser(false);
    }
  }

  async function handleSubmit(e) {
    try {
      setLoading(true);
      setError('');
      setDateError('');

      inputRef.current.setErrors({});

      const produto = e.product_id;
      const atend = e.atendimento;
      const userId = e.user_id;

      const data = new FormData();

      data.append('produto', produto);
      data.append('atendimento', atend);
      data.append('user_id', userId);

      const validateData = {
        product_id: data.get('produto'),
        atendimento: data.get('atendimento'),
      };

      const schema = Yup.object().shape({
        product_id: Yup.string('Selecione um produto').required(
          'Selecione um produto'
        ),
        atendimento: Yup.string('Selecione um atendimento').required(
          'Selecione um atendimento'
        ),
      });

      await schema.validate(validateData, {
        abortEarly: false,
      });

      if (!dates) {
        setDateError('Selecione uma data');
        setLoading(false);
        return;
      }
      data.append('data_init', format(dates, 'yyyy-MM-dd'));

      if (selectedFile.length === 0) {
        setError('Selecione um arquivo csv para importar');
        setLoading(false);
        return;
      }

      data.append('file', selectedFile);

      await api.post('import', data);
      toast.success('Lead inportado com sucesso!');
      setLoading(false);
      history.push('/leads');
    } catch (err) {
      setLoading(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar o lead verifique o produto');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container>
      <h4>Importar leads</h4>
      <Inner>
        <Card>
          <Form
            ref={inputRef}
            onSubmit={e => {
              handleSubmit(e);
            }}
            autoComplete="off"
          >
            <h6>Para importar os leads siga os passos abaixo:</h6>
            <InputArea>
              <Select
                size
                name="product_id"
                labelSelect="Produto:"
                options={products}
                onChange={e => {
                  setSelectedTeam(e.time);
                }}
              />
              <Select
                size
                name="atendimento"
                labelSelect="Formato de atendimento:"
                options={atendimento}
                onChange={e => {
                  showUsers(e);
                }}
              />
            </InputArea>
            <InputArea>
              <DateContainer>
                <DateLabel>Escolha a data do atendimento</DateLabel>
                <DS
                  name="data_init"
                  selected={dates}
                  onChange={date => setDates(date)}
                  locale="pt-BR"
                  placeholderText="Data do atendimento"
                  dateFormat="dd/MM/yyyy"
                  showPopperArrow={false}
                  withPortal
                />
                <ErrorLabel>{dateError}</ErrorLabel>
              </DateContainer>
              {showUser && loading && (
                <Select
                  size
                  name="user_id"
                  labelSelect="Usuário:"
                  options={user}
                />
              )}
            </InputArea>
            <DropContainer>
              <h6>As tabelas precisão ter o seguinte formato:</h6>
              <ul>
                <li>nome</li>
                <li>email</li>
                <li>telefone</li>
              </ul>
              <ErrorLabel>{error}</ErrorLabel>
              <Dropzone onFileUploaded={setSelectedFile} />
            </DropContainer>
            <Button tamanho="40px" load={loading}>
              Cadastrar
            </Button>
          </Form>
        </Card>
      </Inner>
    </Container>
  );
}
